import api from './api';

const addressService = {
  getAll: async () => {
    try {
      const res = await api.get('/addresses');
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.message };
    }
  },

  create: async (address, isPrimary = false, mapLocation = null, alternatePhone = '') => {
    try {
      const payload = {
        address,
        primary: isPrimary ? 'Yes' : 'No',
      };
      if (mapLocation && mapLocation.lat && mapLocation.lng) {
        payload.latitude = mapLocation.lat;
        payload.longitude = mapLocation.lng;
        payload.label = mapLocation.addressInfo?.area ?? '';
      }
      if (alternatePhone) payload.alternatePhone = alternatePhone;
      const res = await api.post('/addresses', payload);
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.message };
    }
  },

  update: async (id, updates) => {
    try {
      const res = await api.patch(`/addresses/${id}`, updates);
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.message };
    }
  },

  setPrimary: async (id) => {
    try {
      const res = await api.patch(`/addresses/${id}/set-primary`);
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.message };
    }
  },

  remove: async (id) => {
    try {
      await api.delete(`/addresses/${id}`);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  },
};

export default addressService;